import {DialogCommandName} from "../components/ha-dialog/dialog-command.enum";

/**
 * The answer of a two-button dialog (`UiHelper.choose`): the primary button (`'confirm'`), the
 * secondary one (`'cancel'`), or `null` when it was closed without choosing (close button, Esc).
 */
export type DialogChoice = 'confirm' | 'cancel' | null;

/**
 * Maps the command a dialog sent to the answer `UiHelper.choose` resolves. Kept apart from
 * `ui.helper.ts` so it can be tested without a DOM. Anything unknown counts as "closed" — a
 * caller must never read an answer the user did not give.
 */
export function dialogCommandToChoice(command: unknown): DialogChoice {
    switch (command) {
        case DialogCommandName.OKAY:
            return 'confirm';
        case DialogCommandName.CANCEL:
            return 'cancel';
        default:
            return null;
    }
}
